import type {
  Space,
  Student,
} from "@/react/components/Spaces/CourseSpace/AdminSummary/Engagement/types";
import { ProgressBar } from "@circle-react/components/Courses/ProgressBar";
import { useStudentProgressModal } from "./ProgressModal";

interface ProgressButtonProps {
  space: Space;
  student: Student;
  variant?: "small" | "full";
}

export const ProgressButton = ({
  student,
  variant = "full",
  space,
}: ProgressButtonProps) => {
  const studentProgressModal = useStudentProgressModal();
  const { progress } = student;
  const onClick = () => studentProgressModal.show({ student, space });

  if (variant === "small") {
    return (
      <button
        onClick={onClick}
        className="focus-visible:outline-secondary flex w-full cursor-pointer items-center gap-3 focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        type="button"
      >
        {`${progress}%`}
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className="focus-visible:outline-secondary flex w-full cursor-pointer items-center gap-3 focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
      type="button"
    >
      <ProgressBar size="sm" variant="inline" progress={progress} />
    </button>
  );
};
